import client from './main-client';

export const getConsultantContactsApi = (params) => client().get(`/consultants-contacts?companyId=${params.companyId}&getAll=true`);

// export const getConsultantContactsApi = (params) => api().get('/consultants-contacts', { params });
export const addNewConsultantContactApi = (data) => client().post('/consultants-contacts', data);
export const deleteConsultantContactsApi = (params) => client().delete('/consultants-contacts', { params });
export const updateConsultantContactsApi = (params) => client().put(`/consultants-contacts/${params.id}`, params.values);
